'use client';
import { MonitorMediaFilterType } from '@mnd-frontend/graphql-schema';
import IconBlog from '@mnd-frontend/icons/components/Blog';
import IconForum from '@mnd-frontend/icons/components/Forum';
import IconLearningVideo from '@mnd-frontend/icons/components/LearningVideo';
import IconPodcast from '@mnd-frontend/icons/components/Podcast';
import IconRadio from '@mnd-frontend/icons/components/Radio';
import IconSocialFacebook from '@mnd-frontend/icons/components/SocialFacebook';
import IconSocialInstagram from '@mnd-frontend/icons/components/SocialInstagram';
import IconSocialLinkedIn from '@mnd-frontend/icons/components/SocialLinkedin';
import IconSocialMedia from '@mnd-frontend/icons/components/SocialMedia';
import IconSocialTiktok from '@mnd-frontend/icons/components/SocialTiktok';
import IconSocialX from '@mnd-frontend/icons/components/SocialX';
import IconSocialYoutube from '@mnd-frontend/icons/components/SocialYoutube';
import IconStory from '@mnd-frontend/icons/components/Story';
import IconTV from '@mnd-frontend/icons/components/Tv';
import IconTvWeb from '@mnd-frontend/icons/components/TvWeb';
import { GREY_900, SIZING_1_5 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  gap: 4px;
  align-items: end;
`;

const Name = styled.span<{ $compact: boolean }>`
  font-size: ${props => (props.$compact ? SIZING_1_5 : '0.875rem')};
  line-height: 1;
  color: ${GREY_900};
  font-weight: 500;
`;

type MediaTypeProps = {
  id: MonitorMediaFilterType;
  name: string;
  compact: boolean;
};

const getMediaTypeIcon = (mediaType: MonitorMediaFilterType): React.ComponentType<any> | null => {
  switch (mediaType) {
    case MonitorMediaFilterType.Ether:
      return IconRadio;
    case MonitorMediaFilterType.Podcast:
      return IconPodcast;
    case MonitorMediaFilterType.Print:
      return IconStory;
    case MonitorMediaFilterType.Radio:
      return IconRadio;
    case MonitorMediaFilterType.Tv:
      return IconTV;
    case MonitorMediaFilterType.TvPlay:
      return IconLearningVideo;
    case MonitorMediaFilterType.TvWeb:
      return IconTvWeb;
    case MonitorMediaFilterType.Youtube:
      return IconSocialYoutube;
    case MonitorMediaFilterType.Facebook:
      return IconSocialFacebook;
    case MonitorMediaFilterType.Twitter:
      return IconSocialX;
    case MonitorMediaFilterType.Instagram:
      return IconSocialInstagram;
    case MonitorMediaFilterType.Linkedin:
      return IconSocialLinkedIn;
    case MonitorMediaFilterType.Web:
      return IconStory;
    case MonitorMediaFilterType.Blogs:
      return IconBlog;
    case MonitorMediaFilterType.Forums:
      return IconForum;
    case MonitorMediaFilterType.SocialMedia:
      return IconSocialMedia;
    case MonitorMediaFilterType.Tiktok:
      return IconSocialTiktok;
    default:
      return null;
  }
};

const MediaType = ({ id, name, compact }: MediaTypeProps) => {
  const Icon = getMediaTypeIcon(id);
  if (!Icon) return null;

  return (
    <Container>
      <Icon $color="colorIconsDefault" $size={compact ? 'xxxs' : 'xxs'} />
      <Name $compact={compact}>{name}</Name>
    </Container>
  );
};

export default MediaType;
